// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__omzfn","list":"BalanceDue_list__lKmHu","listRow":"BalanceDue_listRow__3fpVS","total":"BalanceDue_total__2P38f"};